var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDogdocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.65,
    y: 2.65,
    width: 20.7,
    height: 18.7,
    rx: 2.35,
    stroke: "#3545DE",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4755 13.1862L14.4756 13.1669C14.4756 11.7989 13.3673 10.6899 12.0001 10.6899C10.6329 10.6899 9.52457 11.7989 9.52457 13.1669L9.52462 13.1862C8.56211 13.5257 7.87224 14.4438 7.87224 15.523C7.87224 16.891 8.98059 18 10.3478 18C10.9828 18 11.5619 17.7608 12.0001 17.3675C12.4382 17.7608 13.0174 18 13.6524 18C15.0196 18 16.1279 16.891 16.1279 15.523C16.1279 14.4438 15.4381 13.5257 14.4755 13.1862Z",
    stroke: "#3545DE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4755 7.65112C15.4755 8.56297 14.8744 9.30218 14.1329 9.30218C13.3913 9.30218 12.7902 8.56297 12.7902 7.65112C12.7902 6.73922 13.3913 6 14.1329 6C14.8744 6 15.4755 6.73922 15.4755 7.65112Z",
    stroke: "#3545DE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2098 7.65112C11.2098 8.56297 10.6087 9.30218 9.86711 9.30218C9.12562 9.30218 8.52448 8.56297 8.52448 7.65112C8.52448 6.73922 9.12562 6 9.86711 6C10.6087 6 11.2098 6.73922 11.2098 7.65112Z",
    stroke: "#3545DE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.034C18.5 11.9458 17.8989 12.685 17.1574 12.685C16.4158 12.685 15.8147 11.9458 15.8147 11.034C15.8147 10.1221 16.4158 9.38283 17.1574 9.38283C17.8989 9.38283 18.5 10.1221 18.5 11.034Z",
    stroke: "#3545DE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18531 11.034C8.18531 11.9458 7.58417 12.685 6.84263 12.685C6.10113 12.685 5.5 11.9458 5.5 11.034C5.5 10.1221 6.10113 9.38283 6.84263 9.38283C7.58417 9.38283 8.18531 10.1221 8.18531 11.034Z",
    stroke: "#3545DE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogdocs);
export default __webpack_public_path__ + "static/media/dogdocs.d5fc41d8c2777c194146629c4755f9b4.svg";
export { ForwardRef as ReactComponent };